import { ActionTree } from "vuex";
import ReportStoreTypes from "./define-types.store";
import { IReportState } from "../states.store";

const printTemplateActions = <ActionTree<IReportState, any>>{
  /** CALL SERVICE TO POST DATA */
  [ReportStoreTypes.Set.POST_DATA_PRINTTEMPLATE]: (
    { getters, commit },
    action: string
  ) => {
    let payload = getters[ReportStoreTypes.Get.GET_PRINTTEMPLATE];
    return getters.service[ReportStoreTypes.Service.SEND_PRINTTEMPLATE](payload)
      .then((data: any) => {
        return Promise.resolve(data);
      })
      .catch(error => Promise.reject(error));
  },

  /** CALL SERVICE TO GET TEMPLATES DATA */
  [ReportStoreTypes.Get.GET_LOOKUP_TEMPLATES]: (
    { getters, commit },
    propertyIds: number[]
  ) => {
    return getters.service[ReportStoreTypes.Service.GET_LOOKUP_TEMPLATES](
      propertyIds
    )
      .then((data: any) => {
        commit(ReportStoreTypes.Set.SET_LOOKUP_TEMPLATES, data);
      })
      .catch(error => Promise.reject(error));
  },

  /** CALL SERVICE TO GET DOCUMENTS DATA */
  [ReportStoreTypes.Get.GET_LOOKUP_DOCUMENTS]: (
    { getters, commit },
    propertyIds: number[]
  ) => {
    return getters.service[ReportStoreTypes.Service.GET_LOOKUP_DOCUMENTS](
      propertyIds
    )
      .then((data: any) => {
        commit(ReportStoreTypes.Set.SET_LOOKUP_DOCUMENTS, data);
      })
      .catch(error => Promise.reject(error));
  },

  /** CALL SERVICE TO GET PROPERTIES DATA */
  [ReportStoreTypes.Get.GET_LOOKUP_PROPERTIES]: (
    { getters, commit },
    propertyIds: number[]
  ) => {
    if (propertyIds.length == 0)
      commit(ReportStoreTypes.Set.SET_LOOKUP_PROPERTIES, []);
    return getters.propertyService[
      ReportStoreTypes.Service.GET_LOOKUP_PROPERTIES
    ](propertyIds)
      .then((data: any) => {
        commit(ReportStoreTypes.Set.SET_LOOKUP_PROPERTIES, data);
      })
      .catch(error => Promise.reject(error));
  },

  //WA-1935
  /** CALL SERVICE TO GET PROJECTS DATA */
  [ReportStoreTypes.Get.GET_LOOKUP_PROJECTS]: (
    { getters, commit },
    propertyIds: number[]
  ) => {
    if (propertyIds.length == 0)
      commit(ReportStoreTypes.Set.SET_LOOKUP_PROJECTS, []);

    return getters.projectService[
      ReportStoreTypes.Service.GET_LOOKUP_PROJECTS
    ](propertyIds)
      .then((data: any) => {
        commit(ReportStoreTypes.Set.SET_LOOKUP_PROJECTS, data);
      })
      .catch(error => Promise.reject(error));
  },

  /** CALL SERVICE TO GET DEMANDS DATA */
  [ReportStoreTypes.Get.GET_LOOKUP_DEMANDS]: ({ getters, commit }, demandIds: number[]) => {
    if (demandIds.length == 0)
      commit(ReportStoreTypes.Set.SET_LOOKUP_DEMANDS, []);
      
    return getters.demandService[ReportStoreTypes.Service.GET_LOOKUP_DEMANDS](demandIds).then((data: any) => {
        commit(ReportStoreTypes.Set.SET_LOOKUP_DEMANDS, data);
    }).catch(error => Promise.reject(error));
  },

  /** CALL SERVICE TO GET PERSONS DATA */
  [ReportStoreTypes.Get.GET_LOOKUP_PERSONS]: ({ getters, commit }, personIds: number[]) => {
    if (personIds.length == 0)
      commit(ReportStoreTypes.Set.SET_LOOKUP_PERSONS, []);

    return getters.personService[ReportStoreTypes.Service.GET_LOOKUP_PERSONS](personIds).then((data: any) => {
        commit(ReportStoreTypes.Set.SET_LOOKUP_PERSONS, data);
    }).catch(error => Promise.reject(error));
  }
};

export default printTemplateActions;
